/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  // CONFIG
  const SELECTOR_BRAND = '.product-brand';
  const SELECTOR_PRODUCT_ID = '[data-product-id]';
  const SELECTOR_CART_TOGGLE = '.header__cart-toggle';
  const SELECTOR_PRICE_CONTAINER = '.product-price';
  
  // --- PART 1: SALE LABELS ---
  function injectSaleLabels() {
    const productCards = document.querySelectorAll(SELECTOR_PRODUCT_ID);

    productCards.forEach(card => {
      // 1. Avoid duplicates
      if (card.querySelector('.p-sale-label')) return;

      // 2. Find Price Elements
      const priceContainer = card.querySelector(SELECTOR_PRICE_CONTAINER);
      if (!priceContainer) return;

      const compareAtSpan = priceContainer.querySelector('.compare-at-price');
      
      // If there is no compare-at price, there is no sale
      if (!compareAtSpan) return;

      // 3. Extract & Clean Numbers (Remove 'A$', commas, whitespace)
      // Note: We grab the first span in .product-price as the current price
      const currentPriceSpan = priceContainer.querySelector('span:not(.compare-at-price)');
      if (!currentPriceSpan) return;

      const comparePriceRaw = compareAtSpan.innerText.replace(/[^0-9.]/g, '');
      const currentPriceRaw = currentPriceSpan.innerText.replace(/[^0-9.]/g, '');

      const comparePrice = parseFloat(comparePriceRaw);
      const currentPrice = parseFloat(currentPriceRaw);

      if (isNaN(comparePrice) || isNaN(currentPrice) || comparePrice <= currentPrice) return;

      // 4. Calculate Percentage
      const discountPercent = Math.round(((comparePrice - currentPrice) / comparePrice) * 100);

      if (discountPercent > 0) {
        // 5. Create and Inject the Label
        const labelHTML = `<span class="p-sale-label" style="display:none;">Save ${discountPercent}%</span>`;
        
        // Injecting it at the top of the card (inside the LI)
        // 'afterbegin' puts it as the first child of the LI
        card.insertAdjacentHTML('afterbegin', labelHTML);
      }
    });
  }

  // --- PART 2: ADD TO CART BUTTONS ---
  async function injectSingleButton(brandElement, token) {
    if (brandElement.previousElementSibling && brandElement.previousElementSibling.classList.contains('injected-atc-form')) return;

    const container = brandElement.closest(SELECTOR_PRODUCT_ID);
    if (!container) return;

    const productGid = container.getAttribute('data-product-id');
    if (!productGid) return;

    brandElement.classList.add('atc-processing');

    try {
      const response = await fetch('https://' + window.location.hostname + '/api/2023-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({
          query: '{ node(id: "' + productGid + '") { ... on Product { variants(first: 1) { edges { node { id } } } } } }'
        })
      });

      const json = await response.json();
      if (!json.data || !json.data.node) return;

      const variantGid = json.data.node.variants.edges[0].node.id;
      const variantId = variantGid.split('/').pop();
      const productId = productGid.split('/').pop();

      const html = `
        <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-item__action-list button-stack injected-atc-form" enctype="multipart/form-data">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="quantity" value="1">
          <input type="hidden" name="id" value="${variantId}">
          <buy-button class="buy-button">
            <button type="submit" class="product-item__action-button button button--small button--primary" style="width:100%;">Add to cart</button>
          </buy-button>
          <input type="hidden" name="product-id" value="${productId}">
        </form>
      `;

      brandElement.insertAdjacentHTML('beforebegin', html);

      const injectedForm = brandElement.previousElementSibling;
      if (injectedForm) {
        injectedForm.addEventListener('click', (e) => e.stopPropagation());
        injectedForm.querySelectorAll('button').forEach(btn => btn.addEventListener('click', (e) => e.stopPropagation()));
        
        injectedForm.addEventListener('submit', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const formData = new FormData(injectedForm);
          const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const addUrl = rootUrl + (rootUrl.endsWith('/') ? 'cart/add.js' : '/cart/add.js');

          fetch(addUrl, { method: 'POST', body: formData })
            .then(res => res.json())
            .then(cartItem => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: { quantity: 1, variant: cartItem }
              }));
              const cartToggle = document.querySelector(SELECTOR_CART_TOGGLE);
              if (cartToggle) cartToggle.click();
            })
            .catch(err => console.error(err));
        });
      }
    } catch (e) {
      console.error('Error injecting button:', e);
    }
  }

  function runInjector(token) {
    // 1. Run Sale Labels Logic
    injectSaleLabels();

    // 2. Run ATC Button Logic
    document.querySelectorAll(SELECTOR_BRAND).forEach(el => {
      if (!el.classList.contains('atc-processing')) injectSingleButton(el, token);
    });

    // 3. Observer (Runs both when new items appear)
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          // Re-run label injection whenever DOM changes
          injectSaleLabels(); 
          
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              if (node.matches && node.matches(SELECTOR_BRAND)) injectSingleButton(node, token);
              if (node.querySelectorAll) node.querySelectorAll(SELECTOR_BRAND).forEach(el => injectSingleButton(el, token));
            }
          });
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // --- INIT ---
  if (window.PARALLEL_PUBLIC_TOKEN) {
    runInjector(window.PARALLEL_PUBLIC_TOKEN);
  } else {
    window.addEventListener('parallelTokenReady', (e) => runInjector(e.detail));
  }
  
  if (!window.PARALLEL_PUBLIC_TOKEN && sessionStorage.getItem('parallel_public_token')) {
     runInjector(sessionStorage.getItem('parallel_public_token'));
  }

})();